import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useMediaQuery } from "react-responsive";
import classnames from "classnames";
import dompurify from "isomorphic-dompurify";
import { BREAKPOINT_MEDIUM, customPaymentMethods } from "@jti/fe-common";
import { Loading, MessageBox, MessageBoxVariant } from "@jti/ui";
import { DeliveryDetailsSection } from "../../../../components/DeliveryDetailsSection";
import { ShippingDetailsSection } from "../../../../components/ShippingDetailsSection";
import { useAemModel } from "../../../../contexts/AemModelContext";
import { useFailedPaymentFlow } from "../../../../hooks";
import { useOrder } from "../../../../hooks/useOrder";
import { PaymentPageFooter } from "../PaymentPageFooter";
import { PaymentPagePaymentMethodsContainer } from "../PaymentPagePaymentMethodsContainer";
import styles from "./PaymentPageContent.module.scss";
const { sanitize } = dompurify;
export const PaymentPageContent = ({ asideSubmitButtonWrapperRef }) => {
    const { order, orderFetchStatus } = useOrder();
    const [paymentMethodCode, setPaymentMethodCode] = useState("");
    const { isFailedPaymentFlow } = useFailedPaymentFlow();
    const { failedPaymentFlow } = useAemModel();
    const isScreenAboveMobile = useMediaQuery({ minWidth: BREAKPOINT_MEDIUM });
    const isPayOnDeliverySelected = paymentMethodCode === customPaymentMethods.payOnDelivery;
    const handlePaymentMethodChange = (paymentMethod) => {
        setPaymentMethodCode(paymentMethod);
    };
    useEffect(() => {
        //DESP-48488 don't use bfcache for checkout when user backs from payment gateway
        window.addEventListener("pageshow", (event) => {
            if (event.persisted) {
                window.location.reload();
            }
        });
    }, []);
    return (_jsxs("div", { "data-js-id": "payment-step-section", className: classnames(styles.additionInfo, {
            [styles.noSecureBlock]: isPayOnDeliverySelected,
        }), children: [isFailedPaymentFlow && (failedPaymentFlow?.title || failedPaymentFlow?.message) && (_jsx(MessageBox, { className: styles.messageBox, variant: MessageBoxVariant.error, title: failedPaymentFlow?.title, isVisible: true, children: _jsx("div", { dangerouslySetInnerHTML: { __html: sanitize(failedPaymentFlow?.message) } }) })), orderFetchStatus === "pending" && _jsx(Loading, {}), orderFetchStatus === "success" && order?.shippingAddress && (_jsx(ShippingDetailsSection, { shippingAddress: order.shippingAddress, companyName: order.shippingAddress.pickupInformation?.name, className: styles.shippingDetailsSection })), _jsx(DeliveryDetailsSection, {}), _jsx(PaymentPagePaymentMethodsContainer, { paymentMethodCode: paymentMethodCode, handlePaymentMethodChange: handlePaymentMethodChange }), isScreenAboveMobile ? (_jsx(PaymentPageFooter, { paymentMethodCode: paymentMethodCode, "data-testid": "payment-page-footer-desktop" })) : (asideSubmitButtonWrapperRef.current &&
                createPortal(_jsx(PaymentPageFooter, { paymentMethodCode: paymentMethodCode, "data-testid": "payment-page-footer-mobile" }), asideSubmitButtonWrapperRef.current))] }));
};
//# sourceMappingURL=PaymentPageContent.js.map